window.addEventListener('load', () => {
    const components = document.querySelectorAll<HTMLElement>('[data-faq]');
    if (!components.length) return;

    const init_component = (component: HTMLElement) => {
        const items = Array.from(component.querySelectorAll<HTMLElement>('[data-faq-item]'));
        if (!items.length) return;

        const get_toggle = (item: HTMLElement) => item.querySelector<HTMLButtonElement>('[data-faq-toggle]');
        const get_panel = (item: HTMLElement) => item.querySelector<HTMLElement>('[data-faq-panel]');

        const is_open = (item: HTMLElement) => item.classList.contains('is-open');

        const anchor_menu = component.querySelector<HTMLElement>('[data-faq-anchors]');

        const scroll_to = (target: HTMLElement) => {
            const offset = (window.header_height ?? 128) + 24;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({top, behavior: 'smooth'});
        };

        const release_timers = new Map<HTMLElement, number>();

        const release_height = (item: HTMLElement, panel: HTMLElement) => {
            window.clearTimeout(release_timers.get(item));
            release_timers.delete(item);
            if (is_open(item)) {
                panel.style.maxHeight = 'none';
            }
        };

        const open = (item: HTMLElement) => {
            const toggle = get_toggle(item);
            const panel = get_panel(item);
            if (!toggle || !panel) return;

            items.forEach(other => {
                if (other !== item && is_open(other)) {
                    close(other);
                }
            });

            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            panel.style.maxHeight = `${panel.scrollHeight}px`;

            window.clearTimeout(release_timers.get(item));
            release_timers.set(item, window.setTimeout(() => release_height(item, panel), 400));
        };

        const close = (item: HTMLElement) => {
            const toggle = get_toggle(item);
            const panel = get_panel(item);
            if (!toggle || !panel) return;

            window.clearTimeout(release_timers.get(item));
            release_timers.delete(item);

            panel.style.maxHeight = `${panel.scrollHeight}px`;
            void panel.offsetHeight;
            panel.style.maxHeight = '0px';

            item.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
        };

        const toggle_item = (item: HTMLElement) => {
            if (is_open(item)) {
                close(item);
            } else {
                open(item);
            }
        };

        const focus_item = (index: number) => {
            const target = items[(index + items.length) % items.length];
            get_toggle(target)?.focus();
        };

        items.forEach((item, index) => {
            const toggle = get_toggle(item);
            const panel = get_panel(item);
            if (!toggle || !panel) return;

            panel.style.maxHeight = '0px';

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                toggle_item(item);
            });

            toggle.addEventListener('keydown', (e) => {
                switch (e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        focus_item(index + 1);
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        focus_item(index - 1);
                        break;
                    case 'Home':
                        e.preventDefault();
                        focus_item(0);
                        break;
                    case 'End':
                        e.preventDefault();
                        focus_item(items.length - 1);
                        break;
                }
            });

            panel.addEventListener('transitionend', (e) => {
                if (e.propertyName !== 'max-height' || e.target !== panel) return;
                release_height(item, panel);
            });
        });

        const parts = Array.from(component.querySelectorAll<HTMLElement>('[data-faq-part]'));

        component.querySelectorAll<HTMLAnchorElement>('[data-faq-anchor]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                const id = anchor.getAttribute('href')?.substring(1);
                const part = parts.find(part => part.id === id);
                if (!id || !part) return;

                e.preventDefault();
                scroll_to(part);
                history.replaceState(null, '', `#${id}`);
            });
        });

        const handle_hash = () => {
            const hash = window.location.hash.substring(1);
            if (!hash) return;

            const part = parts.find(part => part.id === hash);
            if (part) {
                scroll_to(part);
                return;
            }

            const item = items.find(item => {
                const toggle = get_toggle(item);
                const panel = get_panel(item);
                return toggle?.id === hash || panel?.id === hash;
            });
            if (!item) return;

            if (!is_open(item)) {
                open(item);
            }

            scroll_to(item);
        };

        window.addEventListener('hashchange', handle_hash);
        handle_hash();
    };

    components.forEach(init_component);
});
